module.exports = __webpack_public_path__ + "img/sv.83c58279.svg";